export const TABLE_COLUMNS_PREFIX = 'table-columns__';
export const FILTER_VIEWS_PREFIX = 'view-filters__';
export const FILTER_BAR_STATE_PREFIX = 'filter-bar-state__';
export const YOUTUBE_VIDEO_PREFIX = 'youtube-video__';
export const BANNER_PREFIX = 'view-banner__';
export const ENDPOINT = '/user/meta';
